import React from "react";
import PropTypes from "prop-types";
import useDevice from "hooks/useDevice";
//import { ProcessArrowContainer, Shaft, Arrowhead } from "./ProcessArrow.styled";

const ProcessArrow = ({
  color,
  length,
  showArrowhead,
  lineWidth,
  dashArray,
}) => {
  const { isDesktop } = useDevice();
  const arrowColor = color || "#1e3a8a";
  const arrowLength = length || 200; // Prilagodio sam podrazumevanu dužinu prema vašem SVG-u
  const strokeWidth = lineWidth || 4.5; // Podrazumevana širina linije prema vašem SVG-u
  const calculatedDashArray = dashArray || "9 13.5"; // Podrazumevano nema isprekidane linije

  return (
    <svg
      width={arrowLength}
      height="27"
      viewBox={`0 0 ${arrowLength} 27`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: isDesktop ? "none" : "rotate(90deg)",
        transformOrigin: "center",

      }}
    >
      <path
        d={`M2.34863 13.5L${arrowLength - (showArrowhead ? 15 : 0)} 13.5`}
        stroke={arrowColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={calculatedDashArray}
      />
      {showArrowhead && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={`M${arrowLength - 15.278} 3.44541C${
            arrowLength - 12.095
          } 6.62867 ${arrowLength - 8.912} 9.81187 ${
            arrowLength - 5.728
          } 12.9951C${arrowLength - 5.476} 13.2476 ${
            arrowLength - 5.476
          } 13.7526 ${arrowLength - 5.728} 14.0051L${
            arrowLength - 15.278
          } 23.5547C${arrowLength - 15.556} 23.8325 ${
            arrowLength - 15.556
          } 24.287 ${arrowLength - 15.278} 24.5647L${
            arrowLength - 13.271
          } 26.5716C${arrowLength - 12.993} 26.8494 ${
            arrowLength - 12.539
          } 26.8494 ${arrowLength - 12.261} 26.5716L${
            arrowLength - 0.705
          } 14.0051C${arrowLength - 0.427} 13.7273 ${
            arrowLength - 0.427
          } 13.2728 ${arrowLength - 0.705} 12.9951L${
            arrowLength - 13.271
          } 0.428573C${arrowLength - 12.539} 0.150761 ${
            arrowLength - 12.993
          } 0.150761 ${arrowLength - 12.261} 0.428573L${
            arrowLength - 15.278
          } 2.43539C${arrowLength - 15.556} 2.71309 ${
            arrowLength - 15.556
          } 3.16766 ${arrowLength - 15.278} 3.44541Z`}
          fill={arrowColor}
        />
      )}
    </svg>
  );
};

ProcessArrow.propTypes = {
  color: PropTypes.string,
  length: PropTypes.number,
  showArrowhead: PropTypes.bool,
  lineWidth: PropTypes.number,
  dashArray: PropTypes.string,
};

ProcessArrow.defaultProps = {
  color: "#1e3a8a",
  length: 200,
  showArrowhead: true,
  lineWidth: 4.5,
  dashArray: "9 13.5",
};
export default ProcessArrow;
